import { render, staticRenderFns } from "./approve-payroll.vue?vue&type=template&id=ad9fbbaa&"
import script from "./approve-payroll.vue?vue&type=script&lang=js&"
export * from "./approve-payroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports